import React from 'react'
import find from 'lodash/find'

import {
  compose,
  setDisplayName,
  withState,
  withProps,
  lifecycle,
} from 'recompose'

const findCurrentChild = (Children, currentKey) => {
  if (!currentKey) {
    return Children[0]
  }
  // Children = react children
  return find(Children, ({ props }) => (
    props.tabValue === currentKey
  ))
}

const assignPropsToChildren = (children, ...props) => {
  return React.Children.map(children, (child) => (
    React.cloneElement(child, {
      ...props,
    })
  ))
}

export const withTabs = (Tab) => compose(
  setDisplayName('Tabs'),
  withState('currentKey', 'setCurrentKey', ''),
  lifecycle({
    componentDidMount() {
      const { defaultTabValue, setCurrentKey } = this.props
      if (defaultTabValue) {
        setCurrentKey(defaultTabValue)
      }
    },
    componentWillReceiveProps(nextProps) {
      const { defaultTabValue, setCurrentKey } = nextProps
      if(defaultTabValue && this.props.defaultTabValue !== defaultTabValue){
        setCurrentKey(defaultTabValue)
      }
    },
  }),
  withProps(({ currentKey, setCurrentKey, onTouchTab = () => {}, length }) => ({
    renderTabs: (children) => {
      // eslint-disable-next-line react/prop-types
      const renderTab = ({ tabValue, tabLabel, primary, size, ...others }, defaultTabValue) => (
        <Tab
          key={tabValue}
          tabLabel={tabLabel}
          isActive={tabValue === (currentKey || defaultTabValue)}
          primary={primary}
          size={size}
          length={length}
          onTouchTap={
            () => {
              onTouchTab(tabValue)
              return setCurrentKey(tabValue)
            }
          }
          {...others} // prop from child of Tab
        />
      )
      try {
        const Children = React.Children.toArray(children)
        return Children.map(({ props }) => renderTab(props, Children[0].props.tabValue))
      } catch (_) {
        return children.map((child) => renderTab(child, children[0].tabValue))
      }
    },
    renderContent: (children, ...args) => {
      try {
        const Children = React.Children.toArray(assignPropsToChildren(children, ...args))
        return findCurrentChild(Children, currentKey)
      } catch (_) {
        return (children.find(({ tabValue }) => tabValue === currentKey) || children[0]).children
      }
    },
  })),
)



// WEBPACK FOOTER //
// ./src/components/Tabs/withTabs.js